import { AnimatePresence, motion } from 'framer-motion';
import { FeatureSlider } from './FeatureSlider';
import { KnowledgeVideoSlide } from './KnowledgeVideoSlide';
import { TermsSlide } from './TermsSlide';
import { WelcomeSlide } from './WelcomeSlide';
import { useIsKnowledge } from '../../hooks/useIsKnowledge';
import { useOnboarding } from '../../hooks/useOnboarding';

export const Onboarding = () => {
    const { isKnowledge } = useIsKnowledge();
    const {
        shouldShowOnboarding,
        isLoading,
        handleTermsChange,
        termsAccepted,
        handleNextStepTerms,
        nextStep,
        step,
        handleSkip,
        privacyPolicyAccepted,
        handleAcceptedPrivacyPolicy,
        t,
    } = useOnboarding();
    const handleFeatureSliderComplete = isKnowledge ? nextStep : handleSkip;

    if (!shouldShowOnboarding || isLoading) {
        return null;
    }

    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center"
            >
                <motion.div
                    initial={{ scale: 0.9, opacity: 0, y: 20 }}
                    animate={{ scale: 1, opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, ease: 'easeOut' }}
                    className="flex flex-col bg-gray-qm-50 dark:bg-gray-qm-900 rounded-2xl shadow-2xl w-[90vw] min-h-[400px] max-w-xl overflow-hidden"
                >
                    {step === 0 && <WelcomeSlide onNext={nextStep} />}
                    {step === 1 && (
                        <TermsSlide
                            onHandleTermsChange={handleTermsChange}
                            termsAccepted={termsAccepted}
                            handleNextStepTerms={handleNextStepTerms}
                            setPrivacyPolicyAccepted={handleAcceptedPrivacyPolicy}
                            privacyPolicyAccepted={privacyPolicyAccepted}
                            buttonText={t('onboarding.terms.buttonTextFirst')}
                        />
                    )}
                    {step === 2 && <FeatureSlider onNext={handleFeatureSliderComplete} />}
                    {step === 3 && isKnowledge && <KnowledgeVideoSlide onComplete={handleSkip} />}
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};
